import { Component, WritableSignal, ChangeDetectionStrategy } from '@angular/core'
import { ModalComponent } from './modal/modal.component'
import { ModalService } from '../../../services/modal.service'
import { TranslocoDirective } from '@jsverse/transloco'
import { BaseButtonComponent } from '../base/base-button/base-button.component'

export interface LogoutModalData {
	title: string;
	body: string;
}

@Component({
	selector: 'logout-modal',
	imports: [ModalComponent, TranslocoDirective, BaseButtonComponent],
	styles: '',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-modal *transloco="let t" (closed)="modalService.close('logout')">
			<div modal-title>
				<h2>{{ data()?.title || t('message.info.notification') }}</h2>
			</div>

			<div modal-body>
				<p>{{ data()?.body || t('message.info.loggedFromAnotherDevice') }}</p>
			</div>

			<div modal-footer>
				<base-button variant="primary" (click)="modalService.close('logout')">
					{{ t('actions.confirm') }}
				</base-button>
			</div>
		</app-modal>
	`
})
export class LogoutModalComponent {
	public data: WritableSignal<LogoutModalData | null>

	constructor(public modalService: ModalService) {
		this.data = this.modalService.getData('logout')
	}
}
